import axios from "@/lib/axios";
import { CompanyMainContact, CompanySegment } from "@/types/company";

type GetCompanyByIdRequestParams = {
  companyId: string;
};

export type GetCompanyByIdResponse = {
  id: string;
  taxId: string;
  name: string;
  tradeName: string;
  website: string;
  principalProduct: string;
  yearOfOperationsStart: string;
  mainContact: CompanyMainContact;
  editions: Editions;
  address: { street: string };
  segment: CompanySegment | null;
};

type Editions = {
  editions: string[];
};

export const getCompanyById = (params: GetCompanyByIdRequestParams) =>
  axios
    .get<GetCompanyByIdResponse>(`/v1/companies/${params.companyId}`)
    .then((res) => res.data);
